import React from 'react';

import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import styled from 'styled-components';

type Props = {
  show: boolean;
  onClose: () => void;
  message: string;
  title: string;
  onConfirm: () => void;
};

const MessageContainer = styled.div`
  color: #4c5a84;
  text-align: left;
`;

const ConfirmModal: React.FC<Props> = ({ show, onClose, message, onConfirm, title }: Props) => {
  return (
    <Modal show={show} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MessageContainer>{message}</MessageContainer>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
